import { Box, Flex, Text } from '@chakra-ui/react';
import { features } from '@ui/components/Features';
import { InDesktop, InMobile } from '@ui/components/MobileOrDesktop';
import { SwiperSlide, SwiperWithScale } from '@ui/components/Swiper';
import { isFeatureEnabled } from '@ui/hooks/useIsFeatureEnabled';
import { useTranslations } from '@ui/i18n';
import { GardenWaterBoostCard } from '@ui/views/Garden/GardenBoostCard/GardenWaterBoostCard';
import React from 'react';

import LockVnoCard from './LockVnoCard';
import { UseVnoCard } from './UseVnoCard';

function EarnWithVno() {
  const t = useTranslations();

  return (
    <Box px={4}>
      <Flex
        flexDir="column"
        maxW={{
          base: 'auto',
          desktop: '736px',
        }}
        margin="auto"
        alignItems="stretch"
      >
        <Text
          as="h1"
          textStyle={{
            base: 'h3',
            desktop: 'h1',
          }}
          textAlign={{
            base: 'start',
            desktop: 'center',
          }}
        >
          {t('Earn with VNO')}
        </Text>
        <Text
          mt={{
            base: 4,
            desktop: '24px',
          }}
          textStyle={{
            base: 'bodyBold',
            desktop: 'h3',
          }}
          textAlign={{
            base: 'start',
            desktop: 'center',
          }}
        >
          {t('Lock your VNO and earn rewards')}
        </Text>
        <Text
          mt={1}
          textStyle={{
            base: 'body',
            desktop: 'h4',
          }}
          textAlign={{
            base: 'start',
            desktop: 'center',
          }}
          color="text-light"
        >
          {t(
            'Locking VNO into Reservoir & Fountain will boost your harvest from every Garden',
          )}
        </Text>
        <InMobile>
          <Flex mx={-2} mr={0} mt={4} flexDir="column">
            <SwiperWithScale px={2} scaleEnabled={false} slidesPerView={1.2}>
              <SwiperSlide>
                <LockVnoCard type="FOUNTAIN" />
              </SwiperSlide>
              <SwiperSlide>
                <LockVnoCard type="RESERVOIR" />
              </SwiperSlide>
            </SwiperWithScale>
          </Flex>
        </InMobile>
        <InDesktop>
          <Flex gap="16px" alignItems="stretch" mt="21px">
            <LockVnoCard height="auto" w="0" flex="1" type="FOUNTAIN" />
            <LockVnoCard height="auto" w="0" flex="1" type="RESERVOIR" />
          </Flex>
        </InDesktop>
        <GardenWaterBoostCard
          colorTheme={isFeatureEnabled(features.Atom) ? 'default' : 'garden'}
          mt="8px"
        />
        <UseVnoCard
          mt={{
            base: '48px',
            desktop: '38px',
          }}
        />
      </Flex>
    </Box>
  );
}

export default EarnWithVno;
